import { IEnvironment } from "./IEnvironment";

export const environment: IEnvironment = {
	production: false,
};



// WEBPACK FOOTER //
// ./Frontend/src/environments/environment.ts